
						import _i0_ from 'L1VzZXJzL2FsZXhpcy9kZXYvYXN2Zi9naG9zdC1pbWFnZS9jb250ZW50L3RoZW1lcy9jdXN0b20vYXNzZXRzL2ltYWdlcy9ub19pbWFnZS5wbmc=.0.400w.webp';import _i1_ from 'L1VzZXJzL2FsZXhpcy9kZXYvYXN2Zi9naG9zdC1pbWFnZS9jb250ZW50L3RoZW1lcy9jdXN0b20vYXNzZXRzL2ltYWdlcy9ub19pbWFnZS5wbmc=.1.400w.png';import _i2_ from 'L1VzZXJzL2FsZXhpcy9kZXYvYXN2Zi9naG9zdC1pbWFnZS9jb250ZW50L3RoZW1lcy9jdXN0b20vYXNzZXRzL2ltYWdlcy9ub19pbWFnZS5wbmc=.2.800w.webp';import _i3_ from 'L1VzZXJzL2FsZXhpcy9kZXYvYXN2Zi9naG9zdC1pbWFnZS9jb250ZW50L3RoZW1lcy9jdXN0b20vYXNzZXRzL2ltYWdlcy9ub19pbWFnZS5wbmc=.3.800w.png';

						
						export const src = _i1_;
						export const width = 400;
						export const height = 229;
						export const originalWidth = 1400;
						export const originalHeight = 800;
						export const sources = [
							["image/webp",_i0_+" "+"400w"+ "," +_i2_+" "+"800w"],["image/png",_i1_+" "+"400w"+ "," +_i3_+" "+"800w"]
						];